"use client";

import { Check } from '@/app/components/Icons/Phosphoricons';
import GetStartedButton from "@/app/components/Utils/GetStartedButton";

const includedFeatures = [
    'Increased productivity and efficiency',
    'Reduced manual errors',
    'Faster time to market',
    'Scalable workflow solutions',
]

export default function AutomationFeaturePricing() {
    return (
        <div className="bg-white py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-4xl sm:text-center">
                    <h2 className="text-5xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-6xl sm:text-balance">
                        Automation Solutions
                    </h2>
                    <p className="mx-auto mt-6 max-w-2xl text-lg font-medium text-pretty text-gray-500 sm:text-xl/8">
                        Transform your business operations with powerful automation tools that streamline processes, reduce costs, and boost productivity.
                    </p>
                </div>
                <div className="mx-auto mt-16 max-w-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
                    <div className="p-8 sm:p-10 lg:flex-auto">
                        <h3 className="text-3xl font-semibold tracking-tight text-gray-900">Business Automation</h3>
                        <p className="mt-6 text-base/7 text-gray-600">
                            Our automation solutions are designed to eliminate repetitive tasks, standardize workflows, and free your team to focus on high value activities that drive innovation and growth.
                        </p>
                        <div className="mt-10 flex items-center gap-x-4">
                            <h4 className="flex-none text-sm/6 font-semibold text-blue-600">What's included</h4>
                            <div className="h-px flex-auto bg-gray-100" />
                        </div>
                        <ul role="list" className="mt-8 grid grid-cols-1 gap-4 text-sm/6 text-gray-600 sm:grid-cols-2 sm:gap-6">
                            {includedFeatures.map((feature) => (
                                <li key={feature} className="flex gap-x-3">
                                    <Check weight="bold" className="h-6 w-5 flex-none text-blue-600" />
                                    {feature}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:shrink-0">
                        <div
                            className="rounded-2xl bg-gray-50 py-10 text-center ring-1 ring-gray-900/5 ring-inset lg:flex lg:flex-col lg:justify-center lg:py-16">
                            <div className="mx-auto max-w-xs px-8">
                                <p className="text-base font-semibold text-gray-600">Investment that pays for itself Custom Pricing</p>
                                <div className="mt-2 flex justify-center">
                                    <GetStartedButton/>
                                </div>
                                <p className="mt-6 text-xs/5 text-gray-600">
                                    Custom solutions available to match your specific business needs that pays for
                                    itself
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}